import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=2e6b9d5a&scoped=true&"
import script from "./addressDetail.vue?vue&type=script&lang=js&"
export * from "./addressDetail.vue?vue&type=script&lang=js&"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=2e6b9d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b9d5a",
  null
  
)

export default component.exports